import { BUYER_SLUGS } from 'Utilities/buyers';
import { Valuation } from 'Utilities/vehicles/@types/valuation';

export type APIResponse<T> = Promise<{
  data: T;
  status: APIResponseStatus;
}>

export enum APIResponseStatus {
  ERROR = 'ERROR',
  FETCHED = 'FETCHED',
  LOADING = 'LOADING',
  NOT_TRIGGERED = 'NOT_TRIGGERED',
  SUCCESS = 'SUCCESS'
}

export type valuatePayload = {
  appInit: number;
  buyer: keyof typeof BUYER_SLUGS;
  enquiryId: number;
}

export type valuateResponse = Promise<Valuation>;

export type AuthnEndpointSuccessResponse<T> = (response: globalThis.Response) => Promise<{
  json?: T;
  response?: globalThis.Response;
}>;

export type AuthnSignUpResponse = {
  expiresIn: number;
  idToken: string;
  message: string;
  refreshToken: string;
  user: {
    id: string;
  };
};

export type AuthnSignInResponse = {
  message: string;
};

export type AuthnRefreshIdTokenResponse = {
  expiresIn: number;
  idToken: string;
  tokenType: string;
};

export type oneTimeTokenResponse = Promise<{ token: string }>;

export type IncodeDocsCopyEntryResponse = {
  data?: {
    decision?: boolean;
  };
  status?: string;
  statusCode?: number;
  statusMessage?: string;
};
